import utils from "../utils";
import httpService from "../httpService";

export default {
  findAll(searchForm, pageable) {
    let params = utils.merge(searchForm, pageable);
    return httpService.get("/hcMasterCaseRequestView", {params: params});
  }
};



// WEBPACK FOOTER //
// ./src/services/hanhchinh/hcMasterCaseRequestViewService.js